const bannerhome1 = [
  {
    id: 1,
    srcimg: "assets/img/homepage/slider/slider-bg-1.jpg",
    classnames:
      "tp-caption tp-resizeme text-white font-heading font-weight-600",
    classtext: "tp-caption tp-resizeme text-white font-heading font-weight-700",
    datax: "['left','left','left','center']",
    datahset: "['34','34','34','0']",
    datavset1: "['-134','-134','-134','-134']",
    datavset2: "['-63','-63','-63','-63']",
    datavset3: "['2','2','2','2']",
    datavset: "['106','106','106','106']",
    classbtn: "tp-caption",
    subtitle: "CITYX APP",
    title_row_1: "MODERNI GRADOVI I GRAĐANI",
    title_row_2: "DIGITALIZIRANI I INFORMIRANI",
    button_title: "OPŠIRNIJE",
    buttonLink: "/apps/cityx-app",
  },
  {
    id: 2,
    srcimg: "assets/img/homepage/slider/slider-bg-2.jpg",
    classnames:
      "tp-caption tp-resizeme text-white font-heading font-weight-600",
    classtext: "tp-caption tp-resizeme text-white font-heading font-weight-700",
    datax: "['center','center','center','center']",
    datahset: "['0','0','0','0']",
    datavset1: "['-134','-134','-134','-134']",
    datavset2: "['-63','-63','-63','-63']",
    datavset3: "['2','2','2','2']",
    datavset: "['106','106','106','106']",
    classbtn: "tp-caption",
    subtitle: "SPORTTER",
    title_row_1: "OD PRVIH NOGOMETNIH KORAKA",
    title_row_2: "IZGRADI PROFIL PROFESIONALCA!",
    button_title: "OPŠIRNIJE",
    buttonLink: "/apps/sportter",
  },
  /*
  {
    id: 3,
    srcimg: "assets/img/homepage/slider/slider-bg-3.jpg",
    classnames:
      "tp-caption tp-resizeme text-white font-heading font-weight-600",
    classtext: "tp-caption tp-resizeme text-white font-heading font-weight-700",
    datax: "['right','right','left','center']",
    datahset: "['-14','-14','-14','0']",
    datavset1: "['-134','-134','-134','-134']",
    datavset2: "['-63','-63','-63','-63']",
    datavset3: "['2','2','2','2']",
    datavset: "['106','106','106','106']",
    classbtn: "tp-caption",
    subtitle: "CITYX TOUR & PASS",
    title_row_1: "ŠTO VIDJETI I ISKUSITI?",
    title_row_2: "OTKRIVAJU TI NAŠI VODIČI!",
    button_title: "OPŠIRNIJE",
    buttonLink: "/apps/cityx-tour-pass",
  },
  */
];

export default bannerhome1;
